import { metabaseService } from './service';

var metabase = metabaseService();

export default metabase;
